import { EllipsisVertical, Pencil, Trash } from 'lucide-react';

import { useTenantUsers } from '@/data/tenantUser';
import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow,
  TableCell
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import NotFound from '@/components/common/NotFound';
import { convertToDateFormat } from '@/helpers/dateHelpers';
import { Badge } from '@/components/ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

import {
  TENANT_USER_ROLES,
  TENANT_USER_ROLES_TRANSLATED,
  TENANT_USER_STATUS,
  TENANT_USER_STATUS_TRANSLATED
} from '../enums';

const List = () => {
  const tenantUsers = useTenantUsers();

  if (tenantUsers.data.length === 0) {
    return <NotFound title="No Accounts Found" />;
  }

  const getRoleBadgeVariant = (role) => {
    switch (role) {
      case TENANT_USER_ROLES.VIEWER:
        return 'outline';
      case TENANT_USER_ROLES.EDITOR:
        return 'outline';
      case TENANT_USER_ROLES.ADMIN:
        return 'secondary';
      case TENANT_USER_ROLES.ADMIN_OWNER:
        return 'secondary';
      case TENANT_USER_ROLES.MEGA:
        return 'default';
      default:
        return 'default';
    }
  };

  const getStatusBadgeVariant = (status) => {
    switch (status) {
      case TENANT_USER_STATUS.INVITED:
        return 'default';
      case TENANT_USER_STATUS.ACCEPTED:
        return 'outline';
      default:
        return 'default';
    }
  };

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>Invite Status</TableHead>
              <TableHead>Created At</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {tenantUsers.data.map((user) => (
              <TableRow key={user.id}>
                <TableCell className="py-2">
                  {user.user.firstname} {user.user.lastname}
                </TableCell>
                <TableCell className="py-2">{user.user.email}</TableCell>
                <TableCell className="py-2">
                  <Badge variant={getRoleBadgeVariant(user.role)}>
                    {TENANT_USER_ROLES_TRANSLATED[user.role]}
                  </Badge>
                </TableCell>
                <TableCell className="py-2">
                  <Badge variant={getStatusBadgeVariant(user.status)}>
                    {TENANT_USER_STATUS_TRANSLATED[user.status]}
                  </Badge>
                </TableCell>
                <TableCell className="py-2">
                  {convertToDateFormat(user.createdAt)}
                </TableCell>
                <TableCell className="text-right py-2">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="icon" size="icon" aria-label="Open menu">
                        <EllipsisVertical size={18} />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent>
                      <DropdownMenuLabel>
                        {user.user.firstname} {user.user.lastname}
                      </DropdownMenuLabel>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem
                      // onClick={() =>
                      //   handleOpenEditUserDialog(companyUser.uid)
                      // }
                      // disabled={isOptionsDisabled}
                      >
                        <Pencil />
                        Edit User
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem
                        className="text-destructive"
                        // onClick={() =>
                        //   handleOpenDeleteUserDialog(companyUser.uid)
                        // }
                        // disabled={isOptionsDisabled}
                      >
                        <Trash />
                        Delete User
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {tenantUsers.data.length}
        </span>
      </div>
    </>
  );
};

export default List;
